import { HStack, Text } from '@chakra-ui/react';
import { NAV_LINKS } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';

const DesktopNav: React.FC = () => {
  const navigate = useNavigate();
  return (
    <HStack spacing={12} display={{ base: 'none', md: 'flex' }} align="center">
      {NAV_LINKS.map((link, idx) => (
        <Text
          key={idx}
          color="gray.800"
          fontSize="16px"
          fontWeight="normal"
          fontFamily="marketingPage"
          cursor={link.href !== '#' ? 'pointer' : 'default'}
          _hover={link.href !== '#' ? { color: 'green.400' } : {}}
          onClick={() => {
            if (link.href !== '#') navigate(link.href);
          }}>
          {link.label}
        </Text>
      ))}
    </HStack>
  );
};
export default DesktopNav;
